import { createSlice } from "@reduxjs/toolkit";
import {
  ATTRIBUTE_STATE,
  CREATE_ATTRIBUTE_STATE,
  UPDATE_ATTRIBUTE_STATE,
  DELETE_ATTRIBUTE_STATE,
} from "../../state";

const getAttributesSlice = createSlice({
  name: "GET_ATTRIBUTES_SLICE",
  initialState: ATTRIBUTE_STATE,
  reducers: {
    startGetAttributes: (state) => {
      state.attributeLoading = true;
      state.attributeError = null;
    },
    successGetAttributes: (state, action) => {
      state.attributeLoading = false;
      state.attributes = action.payload;
    },
    errorGetAttributes: (state, action) => {
      state.attributeLoading = false;
      state.attributeError = action.payload;
    },
  },
});

const createAttributeSlice = createSlice({
  name: "CREATE_ATTRIBUTES_SLICE",
  initialState: CREATE_ATTRIBUTE_STATE,
  reducers: {
    startCreateAttributes: (state) => {
      state.createAttributeLoading = true;
      state.createAttributeError = null;
    },
    successCreateAttributes: (state, action) => {
      state.createAttributeLoading = false;
      state.createAttribute = action.payload;
    },
    errorCreateAttributes: (state, action) => {
      state.createAttributeLoading = false;
      state.createAttributeError = action.payload;
    },
  },
});

const updateAttributeSlice = createSlice({
  name: "UPDATE_ATTRIBUTES_SLICE",
  initialState: UPDATE_ATTRIBUTE_STATE,
  reducers: {
    startUpdateAttributes: (state) => {
      state.updateAttributeLoading = true;
      state.updateAttributeError = null;
    },
    successUpdateAttributes: (state, action) => {
      state.updateAttributeLoading = false;
      state.updateAttribute = action.payload;
    },
    errorUpdateAttributes: (state, action) => {
      state.updateAttributeLoading = false;
      state.updateAttributeError = action.payload;
    },
  },
});

const deleteAttributeSlice = createSlice({
  name: "DELETE_ATTRIBUTES_SLICE",
  initialState: DELETE_ATTRIBUTE_STATE,
  reducers: {
    startDeleteAttributes: (state) => {
      state.deleteAttributeLoading = true;
      state.deleteAttributeError = null;
    },
    successDeleteAttributes: (state, action) => {
      state.deleteAttributeLoading = false;
      state.deleteAttribute = action.payload;
    },
    errorDeleteAttributes: (state, action) => {
      state.deleteAttributeLoading = false;
      state.deleteAttributeError = action.payload;
    },
    resetDeleteAttributes: (state) => {
      state.deleteAttribute = null;
      state.deleteAttributeError = null;
      state.deleteAttributeLoading = false;
    },
  },
});

export const { startGetAttributes, successGetAttributes, errorGetAttributes } =
  getAttributesSlice.actions;

export const {
  startCreateAttributes,
  successCreateAttributes,
  errorCreateAttributes,
} = createAttributeSlice.actions;

export const {
  startUpdateAttributes,
  successUpdateAttributes,
  errorUpdateAttributes,
} = updateAttributeSlice.actions;

export const {
  startDeleteAttributes,
  successDeleteAttributes,
  errorDeleteAttributes,
  resetDeleteAttributes,
} = deleteAttributeSlice.actions;

export const getAttributesReducer = getAttributesSlice.reducer;
export const createAttributesReducer = createAttributeSlice.reducer;
export const updateAttributesReducer = updateAttributeSlice.reducer;
export const deleteAttributesReducer = deleteAttributeSlice.reducer;
